import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { SummaryCard } from "@pentabd/ui";

import { ROUTES } from "@constants/routes";


// INTERFACE
interface SummaryDataType {
  retirement: number;
  permanentEmployee: number;
  promotion: number;
}

interface EmployeeSummaryStructType {
  label: string,
  value: number,
  link: string,
  border: string,
  text: string,
  bg: string
}
// INTERFACE

const {
  HRM: { RETIREMENTS, PERMANENT, PROMOTION },
} = ROUTES;

export const EmployeeSummary = ({
  data: { retirement, permanentEmployee, promotion },
}: {
  data: SummaryDataType;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const employeeSummaryStruct: EmployeeSummaryStructType[] = [
    {
      label: t("EMPLOYEES.EMPLOYEE_SUMMARY.RETIREMENT"),
      value: retirement,
      link: RETIREMENTS,
      border: "border-primary",
      text: "text-primary",
      bg: "bg-primary-25"
    },
    {
      label: t("EMPLOYEES.EMPLOYEE_SUMMARY.PROMOTION"),
      value: promotion,
      link: PROMOTION,
      border: "border-success",
      text: "text-success",
      bg: "bg-success-25"
    },
    {
      label: t("EMPLOYEES.EMPLOYEE_SUMMARY.PERMANENT_SERVICE"),
      value: permanentEmployee,
      link: PERMANENT,
      border: "border-secondary",
      text: "text-secondary",
      bg: "bg-secondary-25"
    },
  ];

  return (
    employeeSummaryStruct && employeeSummaryStruct.length ?
      <div className="grid-container gap-8">
        {employeeSummaryStruct.map(({
          label,
          value,
          link,
          border,
          text,
          bg
        }: EmployeeSummaryStructType) => (
          <div
            key={label}
            className="grid-item-summary-card"
          >
            <SummaryCard
              label={label}
              value={value || 0}
              styles={{
                border,
                color: text,
                background: bg
              }}
              button={{
                label: t("EMPLOYEES.VIEW_BUTTON"),
                color: "text-white",
                background: "bg-primary",
                onClick: () => navigate(link),
              }}
            />
          </div>
        ))}
      </div> : <></>
  );
};
